import entity from '../../../models/base/clients'

export default [
  {
    path: '/clients',
    meta: {
      entity,
      requiresPermissionTo: 'clients',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/clients/new',
    meta: {
      entity,
      requiresPermissionTo: 'clients',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/clients/:id',
    meta: {
      entity,
      requiresPermissionTo: 'clients',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
